import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { useTranslation } from '@common/hooks/translation';

const WithdrawRequestItem = ({ data, isActive, onClick }) => {
  const t = useTranslation();

  return (
    <div
      className={`ct-withdraw-request ${isActive ? 'ct-withdraw-request-active' : ''}`}
      onClick={() => onClick?.(data)}
    >
      <i className="global-icon icon-terminal-withdraw" />

      <h2>
        {t('Amount')}:
        &nbsp;
        <span>{data.Amount} {data.CurrencyId}</span>
      </h2>

      <h2>
        {t('REQUEST TIME')}:
        &nbsp;
        <span>{moment(data.RequestTime).format('DD.MM.YY HH:mm:ss')}</span>
      </h2>
    </div>
  )
};

WithdrawRequestItem.propType = {
  data: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};

export default WithdrawRequestItem;